<template>
  <v-container fluid>
    <v-row class="mb-3" no-gutters>
    <h2 class="text-h4 mb-3">{{ $t("forms.title") }}</h2>
    <v-spacer />
     <action-button
        button-class="mr-1"
        @click="refreshForms"
        :loading="refreshing"
        icon="$refresh"
        :tooltip="$t('common.refresh')"
        fab
        small
      />
       <action-button
        id="pfid1657214068" 
        :to="{ name: 'add-form'}"
        icon="$add"
        :tooltip="$t('forms.add')"
        color="success"
        fab
        small
        dark
      />
    </v-row>
    <v-card :loading="refreshing" class="mb-3">
      <v-card-title>{{ $t("forms.list.title") }}
     
      </v-card-title>
      <v-card-text v-if="list && list.length > 0">
      <v-chip
        color="info"
        class="mx-1 mb-1"
        outlined
        v-for="f in list"
        :key="f.id"
        :to="{ name: 'form', params: { form: f.id } }"
      >{{ f.name }}</v-chip>
      </v-card-text>
      <v-card-text v-else-if="list && list.length == 0">
            <p class="text-center">{{ $t('forms.noForms')}}</p>
      </v-card-text>
      <v-card-text v-else>
        <v-row justify="start" no-gutters>
          <v-skeleton-loader v-for="i in 8" :key="i" class="mx-1 mb-1" type="chip" />
        </v-row>
      </v-card-text>
    </v-card>
    <transition name="slide-x-transition" mode="out-in">
      <router-view :key="$route.path"></router-view>
    </transition>
  </v-container>
</template>

<script>
import ParseRoute from '@/mixins/parse-route'
import { mapState } from "vuex";

export default {
  name: "Forms",
  mixins: [ParseRoute],
  data() {
    return {
      refreshing: false
    }
  },
  computed: {
    ...mapState("forms", ["list"]),
  },
  methods: {
    loadForms() {
      if (!this.list) {
        this.refreshForms();
      }
    },
    async refreshForms() {
      this.refreshing = true;
      await this.$store.dispatch("forms/list", {
        domainID: this.domain,
      });
      this.refreshing = false;
    },
  },
  created() {
    this.loadForms();
  },
};
</script>

<style>
</style>